<template>
  <div class="date-range-picker">
    <div
      class="calendar-input"
      @click.stop="show = true"
      :class="startDate && endDate ? '' : 'empty-date'"
    >
      <span>{{ startDate ? startDate : "开始日期" }}</span>
      <i class="separator"></i>
      <span>{{ endDate ? endDate : "结束日期" }}</span>
      <van-icon
        v-if="startDate && endDate"
        style="margin-right: 12px"
        name="close"
        @click.stop="clearDates"
      />
      <van-icon v-else style="margin-right: 12px" name="notes-o" />
    </div>

    <van-calendar
      v-model="show"
      allow-same-day
      type="range"
      :min-date="minDate"
      @confirm="handleConfirm"
    />
  </div>
</template>

<script>
export default {
  name: "DateRangePicker",
  props: {
    // 最小可选日期，默认为1970-01-01
    minDate: {
      type: Date,
      default: () => new Date(1970, 0, 1),
    },
    // 外部传入的初始值
    value: {
      type: Object,
      default: () => ({ startDate: null, endDate: null }),
    },
  },
  data() {
    return {
      show: false,
      startDate: this.value.startDate,
      endDate: this.value.endDate,
    };
  },
  watch: {
    value(newVal) {
      this.startDate = newVal.startDate;
      this.endDate = newVal.endDate;
    },
  },
  methods: {
    formatDate(date) {
      if (!(date instanceof Date)) {
        date = new Date(date);
      }
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },
    handleConfirm(dates) {
      const [start, end] = dates;
      this.show = false;
      this.startDate = this.formatDate(start);
      this.endDate = this.formatDate(end);

      // 触发父组件事件
      this.$emit("input", {
        startDate: this.startDate,
        endDate: this.endDate,
      });
      this.$emit("change", {
        startDate: this.startDate,
        endDate: this.endDate,
      });
    },
    clearDates() {
      this.startDate = null;
      this.endDate = null;
      this.$emit("input", {
        startDate: null,
        endDate: null,
      });
      this.$emit("change", {
        startDate: null,
        endDate: null,
      });
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep(
    .van-calendar__popup.van-popup--bottom,
    .van-calendar__popup.van-popup--top
  ) {
  height: 75%;
}
.date-range-picker {
  .calendar-input {
    height: 28px;
    background: #ffffff;
    border-radius: 2px;
    border: 1px solid #e7e7e7;
    display: flex;
    align-items: center;
    justify-content: space-between;

    span {
      display: inline-block;
      flex: 1;
      padding-left: 12px;
      font-family: PingFang SC;
      font-weight: 400;
      font-size: 10px;
      color: #1d2129;
      text-align: left;
    }

    .separator {
      width: 10px;
      height: 1px;
      background: #86909c;
      margin: 0 5px;
    }
  }

  .empty-date {
    span {
      color: #86909c;
    }
  }
}
</style>
